import React from "react"
import { connect } from "react-redux"

import styled from "@emotion/styled"

import { CHANNELS } from "../../utils/general"

import {
  MobileNavWrapper,
  MobileChannels,
  NavSocialIcons,
  SocialIcon,
} from "../styled"

import { toggleExpanded, updateQuery, toggleLogoVisible } from "../../actions"

import shopIcon from "../../images/ShopArrow.png"

import ShopButton from "../shopbutton"
import MobileChannel from "./mobilechannel"

const ShopExitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  .toggle-nav {
    margin-top: 0;
    margin-left: 0;
    span {
      transform: rotate(45deg) !important;
      top: 0;
      width: 20px;
      &:before {
        top: 5px;
        background: #fff
      }
      &:after {
        top 5px;
        background: #fff;
        transform: rotate(-90deg) !important;
      }
    }
  }
`

const HamburgerOpenCloseContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  float: right;
`
const HamburgerOpenCloseIcon = styled.span`
  position: absolute;
  z-index: 10;
  width: 3.6rem;
  height: 1.8rem;
  cursor: pointer;
  span,
  span:before,
  span:after {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    text-indent: -9999px;
    background-color: #2d2d2d;
    height: 2px;
    width: 20px;
  }
  span {
    width: 20px;
    margin-left: 0.3rem;
    margin-top: 0.3rem;
  }
  span:before {
    top: 10px;
  }
  span:after {
    top: 5px;
  }
`

const MobileNav = (props) => {
  const {
    logoVisible,
    toggleLogoVisible,
    toggleExpanded,
    expanded,
    updateQuery,
  } = props

  const channelClick = () => {
    if (!logoVisible) {
      toggleLogoVisible(true)
    }
    if (expanded) {
      toggleExpanded(!expanded)
      updateQuery("")
    }
  }

  const homeData = {
    data: {
      name: "Home",
      slug: "/",
    },
    id: "xfjeowjfkdsljfkdsl",
  }

  const renderChannels = () => {
    return CHANNELS.map((channel, idx) => (
      <MobileChannel
        channel={channel}
        key={channel.id}
        outerClick={props.outerClick}
        channelClick={channelClick}
      />
    ))
  }

  const renderIcons = () => {
    return props.icons.map((icon) => {
      return (
        <SocialIcon>
          <a href={icon.link} target="_blank">
            <img src={icon.icon} alt={icon.alt} />
          </a>
        </SocialIcon>
      )
    })
  }

  return (
    <MobileNavWrapper>
      <ShopExitWrapper>
        <ShopButton mobileNav={true} image={shopIcon} />
        <HamburgerOpenCloseContainer className="burger-container">
          <HamburgerOpenCloseIcon
            className="toggle-nav"
            onClick={() => props.toggleMobileNav()}
          >
            <span>{`Toggle Navigation`}</span>
          </HamburgerOpenCloseIcon>
        </HamburgerOpenCloseContainer>
      </ShopExitWrapper>
      <MobileChannels>{renderChannels()}</MobileChannels>
      <NavSocialIcons>{renderIcons()}</NavSocialIcons>
    </MobileNavWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    expanded: state.searchBarExpandedReducer.expanded,
    logoVisible: state.logoVisibleReducer.logoVisible,
  }
}

export default connect(mapStateToProps, {
  toggleExpanded,
  updateQuery,
  toggleLogoVisible,
})(MobileNav)
